import React from 'react';
import NavUnauth from './components/nav-unauth';
import { AuthPageSC, IAuthPageSC } from './auth.styled';

interface AuthLayoutProps extends IAuthPageSC {
  children: React.ReactNode;
}

const AuthLayout: React.FunctionComponent<AuthLayoutProps> = ({ children, ...rest }) => {
  return (
    <AuthPageSC {...rest}>
      <NavUnauth />
      {children}
    </AuthPageSC>
  );
};

export default AuthLayout;
